export enum OpDayViewAction {
  View = 'view',
  Validate = 'validate',
  ValidateViewResults = 'validateviewresults',
  Status = 'opstatus',
}

export enum OpDayOperAction {
  Block = 'block',
  Unblock = 'unblock',
  Open = 'open',
  Close = 'close',
  OpenAccountOnly = 'open_acconly',
  CloseAccountOnly = 'close_acconly',
  Lock = 'lock',
}

export enum OpDayServiceErrorCode {
  GENERAL,
}

export interface OpDayFailure {
  message: string
}

export interface OpDayViewServerData {
  Open_Day: string
  DirtyDate: string
  AccDate: string
  CreditDate: string
  Cur_Date: string
  BlockedDate: string
}

export interface OpDayValidateServerData {
  WHLSessionID: number
  HashSum_WHLSessionID_: string
  ErrorLevel: number
}
